/**
 * Extract file extension from URL
 * @param fileUrl - The URL of the file
 * @returns string | null - File extension in lowercase
 */
export const getFileExtension = (fileUrl: string | null | undefined): string | null => {
  if (!fileUrl) return null

  return fileUrl.split('.').pop()?.toLowerCase() || null
}
